module.exports = __webpack_public_path__ + "static/media/grid-menu.f2842214.svg";